import { Component } from "react";
import { withRouter } from "../../../withRouter";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import VoiceReservation from "./VoiceReservation";
import Conversations from "./Conversations";
import EmbedDocs from "./EmbedDocs";
import Settings from "./Settings";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import axios from "axios";
import cookie from "react-cookies";

import Reservations from "./Reservations";
class Reservation extends Component {
  constructor(props) {
    super(props);
    const companyID = cookie.load("companyID") || "";
    this.state = {
      companyID: companyID,
      showAddOutlet: true,
    };
  }
  componentDidMount() {
    this.loadOutlet();
  }
  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropdown?company_id=" + this.state.companyID;
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
         const ids = result
  .filter(item =>
    typeof item?.outletsupabaseReservationOutletID === "string" &&
    item.outletsupabaseReservationOutletID.trim() !== ""
  )
  .map(item => item.outletsupabaseReservationOutletID);
          console.log(ids, 'idsidsidsidsids')
          const emptyOrMissingCount = result.filter((item) => {
            const id = item?.outletsupabaseReservationOutletID;
            return id === null || id === undefined || (typeof id === "string" && id.trim() === "");
          }).length;
          this.setState({ outletList: result, loading: false, supabaseoutletIDs_: ids, showAddOutlet:emptyOrMissingCount>0?true:false }, () => {
            if (this.state.supabaseoutletIDs_.length === 0) {
              this.props.navigate("/clientpanel/reservation/settings");
            }
          });
        }
      })
      .catch();
  }
  onRecallOulet(recall) {
    if (recall === true) {
      this.loadOutlet();
    }
  }
  render() {
    console.log(this.props, this.props.params, "sddsdasdsadsa");
    let currentPage = "reservation";
    if (this.props.location.pathname === "/clientpanel/reservation/dashboard") {
      currentPage = "res-dashboard";
    } else if (this.props.location.pathname === "/clientpanel/reservation/conversations") {
      currentPage = "conversations";
    } else if (this.props.location.pathname === "/clientpanel/reservation/embed-docs") {
      currentPage = "embed-docs";
    } else if (this.props.location.pathname === "/clientpanel/reservation/settings") {
      currentPage = "res-settings";
    } else if (this.props.location.pathname === "/clientpanel/reservation") {
      currentPage = "reservation";
    }
    return (
      <div className="layout-wrapper layout-content-navbar reservation-main">
        <div className="layout-container">
          <Header {...this.props} currentPage={currentPage} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                {this.props.location.pathname === "/clientpanel/reservation/dashboard" && <VoiceReservation />}
                {this.props.location.pathname === "/clientpanel/reservation/conversations" && <Conversations />}
                {this.props.location.pathname === "/clientpanel/reservation/embed-docs" && <EmbedDocs />}
                {this.props.location.pathname === "/clientpanel/reservation/settings" && (
                  <Settings props={this.props} outletList={this.state.outletList} onRecallOulet={this.onRecallOulet.bind(this)} showAddOutlet={this.state.showAddOutlet} />
                )}
                {this.props.location.pathname === "/clientpanel/reservation" && <Reservations />}
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

export default withRouter(Reservation);
